import styled from "styled-components";

import { COLORS } from "~/src/styles/config.style";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const Dialog = styled.div`
  background: ${COLORS.WHITE};
  width: 100%;
  max-width: 420px;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.25);
`;

export const Heading = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const Message = styled.div`
  margin-bottom: 16px;
  color: ${COLORS.BLACK};
  line-height: 1.4;
`;

export const BookingCount = styled.div<{ color?: string }>`
  font-weight: bold;
  font-size: 120%;
  margin-top: 6px;
  color: ${(props) => props.color || COLORS.BLACK};
`;

export const Actions = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  margin-top: 4px;
`;

export const Action = styled.div`
  flex: 1;
  margin: 0;

  & > * {
    width: 100%;
    margin: 0;
  }
`;
